import { useState, useEffect } from 'react';
import { themes } from './ThemeContext';
import COLORS from './colors';

const themeName = 'theme';

const UseCustomTheme = (initialTheme: string = themes.light): [string, (item: string) => void] => {
  let userTheme: string = initialTheme;
  if (localStorage) {
    const theme: string | null = localStorage.getItem(themeName);
    if (theme) {
      userTheme = theme;
    }
  }
  const [theme, setThemeInternally] = useState(userTheme);

  function setTheme(chosenTheme: string): void {
    const newTheme: string = themes[chosenTheme];
    if (localStorage) {
      localStorage.setItem(themeName, newTheme);
    }
    setThemeInternally(newTheme);
  }

  useEffect(() => {
    const selectedTheme = COLORS[theme];
    for (const [propKey, propVal] of Object.entries(selectedTheme)) {
      document.documentElement.style.setProperty(`--${propKey}`, `${propVal}`);
    }
  }, [theme]);

  return [theme, setTheme];
};

export default UseCustomTheme;
